import { NavLink } from 'react-router';

import { Flex } from '@chakra-ui/react';

import { useBoolean } from '@enterprise/hooks';
import { HasAccess } from '@enterprise/ui';

import Billing from '@components/billing/billing';

import CalendarMenu from './components/calendar-menu';
import MailingListsMenu from './components/mailing-lists-menu';
import MailingsMenu from './components/mailings-menu';
import NavItem from './components/nav-item';

export default function NavBar() {
  const [isOpen, { off: closeBilling, on: openBilling }] = useBoolean();

  return (
    <>
      <Flex
        alignItems="center"
        as="nav"
        bg="gray.200"
        gap={2}
        px={7}
        py={2}>
        <NavLink to="/datastream/packagemanager">
          {({ isActive }) => {
            return <MailingsMenu isActive={isActive} />;
          }}
        </NavLink>
        <NavLink to="/datastream/listmanager">
          {({ isActive }) => {
            return <MailingListsMenu isActive={isActive} />;
          }}
        </NavLink>
        <HasAccess permissions={['dts-view-blueprints']}>
          <NavLink to="/datastream/blueprintmanager">
            {({ isActive }) => {
              return (
                <NavItem
                  isActive={isActive}
                  label="Blueprint Manager"
                />
              );
            }}
          </NavLink>
        </HasAccess>
        <NavLink to="/datastream/calendar">
          {({ isActive }) => {
            return <CalendarMenu isActive={isActive} />;
          }}
        </NavLink>
        <HasAccess permissions={['dts-view-billing']}>
          <NavItem
            as="button"
            isActive={isOpen}
            label="Billing"
            onClick={openBilling}
          />
        </HasAccess>
        <HasAccess
          ml="auto"
          permissions={['dts-view-admin-panel']}>
          <NavLink to="/datastream/admin">
            {({ isActive }) => {
              return (
                <NavItem
                  isActive={isActive}
                  label="Admin"
                />
              );
            }}
          </NavLink>
        </HasAccess>
      </Flex>
      {isOpen && <Billing onClose={closeBilling} />}
    </>
  );
}
